import React from "react";
import { Link } from "react-router-dom";
import "../Styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-main">
        {/* Logo and company info */}
        <div className="footer-logo-section">
          <div className="footer-logo">
            {/* <img
              src="./Assets/Images/rba.png" // Update with your actual logo path
              alt="RBA Gayrimenkul Logo"
            /> */}
            <span>RBA Gayrimenkul</span>
          </div>
          <div className="company-info">
            <p>
              <i className="fa fa-id-card"></i> Yetki Numaramız:{" "}
              <strong> 2600931 - 2601031</strong>
            </p>
          </div>
        </div>

        {/* Footer content */}
        <div className="footer-content">
          {/* Branches Section */}
          <div className="footer-section">
            <h2>Şubelerimiz</h2>
            <div className="branch-info">
              <h3>Deliklitaş Şubemiz</h3>
              <p>
                <i className="fa fa-map-marker-alt"></i> Deliklitaş Mahallesi,
                Deliklitaş Cd. No:22, Eskişehir
              </p>
            </div>
            <div className="branch-info">
              <h3>Vatan Caddesi Şubemiz</h3>
              <p>
                <i className="fa fa-map-marker-alt"></i> Kurtuluş, Vatan Cd.
                No:43, 26090 Odunpazarı, Eskişehir
              </p>
            </div>
          </div>

          {/* Site Links Section */}
          <div className="footer-section">
            <h2>Hızlı Erişim</h2>
            <ul>
              <li>
                <Link to="/">Ana Sayfa</Link>
              </li>
              <li>
                <Link to="/ilanlar">İlanlar</Link>
              </li>
              <li>
                <Link to="/iletisim">İletişim</Link>
              </li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="footer-section">
            <h2>Sosyal Medya</h2>
            <ul className="footer-social-links">
              <li>
                <a
                  href="https://www.facebook.com/people/RBA-Gayrimenkul-Dani%C5%9Fmanlik/100063970334586/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook"></i> Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/rba.gayrimenkul/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i> Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://rbagayrimenkul.sahibinden.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Sahibinden"
                >
                  <i className="fas fa-s"></i> Sahibinden
                </a>
              </li>
              <li>
                <a
                  href="https://www.hepsiemlak.com/emlak-ofisi/rba-gayrimenkul-78503/rba-gayrimenkul-1494363"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Hepsiemlak"
                >
                  <i className="fas fa-chevron-up"></i> Hepsiemlak
                </a>
              </li>
              <li>
                <a
                  href="https://www.emlakjet.com/emlak-ofisleri-detay/rba-gayrimenkul-415052/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="EmlakJet"
                >
                  <i className="fas fa-home"></i> EmlakJet
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="footer-divider"></div>

      {/* Bottom section - Copyright */}
      <div className="footer-bottom">
        <div className="footer-copyright">
          © {new Date().getFullYear()} <span>RBA Gayrimenkul</span>. Tüm Hakları
          Saklıdır. Powered by{" "}
          <a
            href="https://kodjet.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Kodjet Yazılım
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
